import { render } from 'preact';
import App from './index';

render(<App />, document.getElementById('app'));
